import { render, staticRenderFns } from "./exchangeRateList.vue?vue&type=template&id=45cfeac0&scoped=true&lang=html&"
import script from "./exchangeRateList.vue?vue&type=script&lang=js&"
export * from "./exchangeRateList.vue?vue&type=script&lang=js&"
import style0 from "./exchangeRateList.vue?vue&type=style&index=0&id=45cfeac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfeac0",
  null
  
)

export default component.exports